module.exports = __webpack_public_path__ + "static/media/check.f5876d3f.svg";